module.exports = __webpack_public_path__ + "static/img/4.c09088f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/sp/4.png
// module id = ZrqF
// module chunks = 0